<template>
  <div>
    <!-- 库存日期范围 -->
    <div>
      <p>当前可选日期：</p>
    </div>
    <!-- 套餐 价格信息 -->
    <el-calendar>
      <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
      <template slot="dateCell" slot-scope="{date, data}">
        <p
          :class="data.isSelected ? 'is-selected' : ''"
        >{{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? 'x' : ''}}</p>
        <div>
          <input class="inside-input" />
        </div>
      </template>
    </el-calendar>
  </div>
</template>

<script>
export default {
  name: "sku-stock"
};
</script>

<style>
.inside-input {
  width: 30%;
  height: 20%;
}
</style>